import { render, staticRenderFns } from "./aftersale_order_complaint_list.vue?vue&type=template&id=437b89f2&scoped=true"
import script from "./aftersale_order_complaint_list.vue?vue&type=script&lang=js"
export * from "./aftersale_order_complaint_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b89f2",
  null
  
)

export default component.exports